// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__67xPH","productName":"Table_productName__22P_U"};